import { ScanLine } from "lucide-react";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Quét & tem — chốt 20/09/2026. Ở đây khác các mục vàng trước: hai quy tắc DEV-R01 / DEV-R02 không phải chính sách
 * của Hisense mà là CÁCH LÀM của ta (không nhận kết quả mô phỏng như kết quả máy thật, thiếu hiệu chuẩn thì gắn nhãn chứ không
 * ép về 0). Phần thật sự phải hỏi khách — hãng / đời máy quét, cân, máy in và quy trình hiệu chuẩn — là DỮ LIỆU của khách, không
 * bịa ra được; nó nằm ở quy tắc "Máy thật" dưới đây và ở mục 7 bộ câu hỏi, nhưng không chặn việc dùng màn quét hằng ngày vì máy
 * quét gõ-ra-chữ và camera điện thoại chạy được ngay.
 */
export const SCAN_RULES_SETTLED = ["work", "channel", "calibration", "label"] as const;

export function ScanRules() {
  return <SettledRules ns="devices" rules={SCAN_RULES_SETTLED} icon={ScanLine} />;
}
